import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row g-0 border-top border-primary" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 bg-danger text-white p-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", null, "Error al cargar los turnos", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "col-12 bg-dark text-white p-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", null, "No se encuentran turnos disponibles.", -1)
const _hoisted_7 = [
  _hoisted_6
]

import { watch } from 'vue'
import AppCardHours from '@/components/AppCardHours.vue'
import useCardTurnos from '@/composables/useCardTurnos'
import { Skeletor } from 'vue-skeletor'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSelectCardHours',
  props: {
    actividadId: null,
    horarios: { type: Boolean },
    dayId: null,
    conAccesoVip: { type: Boolean }
  },
  emits: ['callback'],
  setup(__props: any, { emit }) {

const props = __props as {
  actividadId: number
  horarios?: boolean
  dayId?: number
  conAccesoVip?: boolean
};





const { cards, fetchCard, cardSelected, currentSelectedCards, error, loading } =
  useCardTurnos()
const selectedMe = (id: number) => {
  cardSelected(id)
  emit('callback', currentSelectedCards.value)
}

watch(
  () => props.dayId,
  async () => {
    await fetchCard(props.actividadId, props.dayId, props.conAccesoVip)
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.dayId)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(loading))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(4, (i) => {
                return _createElementVNode("div", {
                  key: i,
                  class: "col-6 col-lg-12 col-xl-4 col-xxl-3"
                }, [
                  _createVNode(_unref(Skeletor), {
                    height: "40",
                    class: "m-1"
                  })
                ])
              }), 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(cards).length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(cards), (card) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-6 col-lg-12 col-xl-4 col-xxl-3",
                        key: card.id
                      }, [
                        _createVNode(AppCardHours, {
                          id: card.id,
                          title: card.title,
                          check: card.selected,
                          onSelectedMe: selectedMe
                        }, null, 8, ["id", "title", "check"])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_unref(error))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                    ], 64))
              ], 64))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})